
export default {
  SET_PEKERJAAN_SEARCH_QUERY (state, query) {
    state.pekerjaanSearchQuery = query
  },
  SET_PEKERJAANS (state, pekerjaans) {
    state.pekerjaans = pekerjaans
  },
  SET_TOTALS (state, payload) {
    state.total = payload
  },
  SET_LAST (state, payload) {
    state.last = payload
  },
  SET_PER_PAGE (state, payload) {
    state.per_page = payload
  },
  SET_CURRENT_PAGE (state, payload) {
    state.current_page = payload
  },
  SET_FILTERS (state, payload) {
    state.filters = payload
  },
  ADD_FILTER (state, item) {
    state.filters.unshift(item)
  },
  ADD_TAG (state, item) {
    state.pekerjaanTags.unshift(item)
  },
  SET_TAGS (state, tags) {
    state.pekerjaanTags = tags
  },
  SET_TAXONOMY (state, taxonomy) {
    state.taxonomy = taxonomy
  },
  SET_RAB (state, rab) {
    state.rab = rab
  },
  ADD_PEKERJAAN (state, item) {
    state.pekerjaans.unshift(item)
    state.total = state.total + 1
  },
  UPDATE_PEKERJAAN (state, pekerjaan) {
    const pekerjaanIndex = state.pekerjaans.findIndex((p) => p.id === pekerjaan.task_parent)
    Object.assign(state.pekerjaans[pekerjaanIndex], pekerjaan)
  },
  SET_META (state, meta) {
    state.meta = meta
  },
  UPDATE_PEKERJAAN_FILTER (state, filterName) {
    state.pekerjaan_filter = filterName
  },
  UPDATE_LABELS (state, payload) {
    payload.pekerjaans.forEach((pekerjaanId) => {
      const pekerjaanIndex = state.pekerjaans.findIndex((pekerjaan) => pekerjaan.id === pekerjaanId)
      const index = state.pekerjaans[pekerjaanIndex].labels.indexOf(payload.label)

      if (index === -1) state.pekerjaans[pekerjaanIndex].labels.push(payload.label)
      else state.pekerjaans[pekerjaanIndex].labels.splice(index, 1)
    })
  },
  SET_LABELS (state, payload) {
    state.pekerjaans.find((pekerjaan) => pekerjaan.id === payload.id).labels = payload.labels
  },
  REMOVE_PEKERJAAN (state, itemId) {
    const ItemIndex = state.pekerjaans.findIndex((p) => p.id === itemId)
    state.pekerjaans.splice(ItemIndex, 1)
  },
  REMOVES_PEKERJAAN (state, payload) {
    payload.pekerjaans.forEach((pekerjaanId) => {
      const ItemIndex = state.pekerjaans.findIndex((p) => p.id === pekerjaanId)
      state.pekerjaans.splice(ItemIndex, 1)
    })
  },
  RESTORE_PEKERJAAN (state, itemId) {
    const ItemIndex = state.pekerjaans.findIndex((p) => p.id === itemId)
    state.pekerjaans.splice(ItemIndex, 1)
  },
  SET_UNREAD (state, payload) {
    payload.pekerjaanIds.forEach((pekerjaanId) => {
      const pekerjaanIndex = state.pekerjaans.findIndex((pekerjaan) => pekerjaan.id === pekerjaanId)
      if (pekerjaanIndex !== -1) state.pekerjaans[pekerjaanIndex].unread = payload.unreadFlag
    })
  },
  MOVE_PEKERJAANS_TO (state, payload) {
    payload.pekerjaanIds.forEach((pekerjaanId) => {
      const pekerjaanIndex = state.pekerjaans.findIndex((pekerjaan) => pekerjaan.id === pekerjaanId)

      // Update draft meta
      // If moving from draft pekerjaanFolder decrease draft meta by removing pekerjaanId
      if (state.pekerjaans[pekerjaanIndex].pekerjaanFolder === 'draft') {
        state.meta.draftPekerjaans.splice(state.meta.draftPekerjaans.findIndex(i => i === pekerjaanId), 1)
      }
      // Else increase by pushing pekerjaanId
      if (payload.to === 'draft') {
        state.meta.draftPekerjaans.push(pekerjaanId)
      }

      state.pekerjaans[pekerjaanIndex].pekerjaanFolder = payload.to
    })
  },

  TOGGLE_IS_PEKERJAAN_STARRED (state, payload) {
    state.pekerjaans.find((pekerjaan) => pekerjaan.id === payload.pekerjaanId).isStarred = payload.value
  },

  // If your process of fetching is different than ours. Please update action and mutation
  // Maybe this mutation is redundant for you. Feel free to remove it.
  UPDATE_UNREAD_META (state, payload) {

    // Loop over pekerjaan meta
    for (const folder in state.meta.unreadPekerjaans.folder) {

      // If folder is same as current filter
      if (folder === state.pekerjaan_filter) {

        if (payload.unreadFlag) {

          // If unread flag is true - increase count
          payload.pekerjaanIds.forEach((pekerjaanId) => {
            if (state.meta.unreadPekerjaans.folder[folder].indexOf(pekerjaanId) === -1) state.meta.unreadPekerjaans.folder[folder].push(pekerjaanId)
          })
        } else {

          // else reduce unread pekerjaans count
          payload.pekerjaanIds.forEach((pekerjaanId) => {
            const pekerjaanIdIndex = state.meta.unreadPekerjaans.folder[folder].indexOf(pekerjaanId)
            if (pekerjaanIdIndex !== -1) state.meta.unreadPekerjaans.folder[folder].splice(pekerjaanIdIndex, 1)
          })
        }

      }
    }
  },
  UPDATE_UNREAD_META_ON_MOVE (state, payload) {

    // Updating Draft meta is handled by "MOVE_PEKERJAANS_TO" mutation

    payload.pekerjaanIds.forEach((pekerjaanId) => {
      const pekerjaan = state.pekerjaans.find((pekerjaan) => pekerjaan.id === pekerjaanId)

      if (pekerjaan.unread) {
        const cf_unread_pekerjaans = state.meta.unreadPekerjaans.folder[state.pekerjaan_filter]
        if (cf_unread_pekerjaans) {
          cf_unread_pekerjaans.splice(cf_unread_pekerjaans.indexOf(pekerjaanId), 1)
        }
        if (state.meta.unreadPekerjaans.folder[payload.to]) state.meta.unreadPekerjaans.folder[payload.to].push(pekerjaanId)
      }
    })
  }
}
